import React from 'react';
import {
    NavLink
  } from "react-router-dom";
import Icon from '@iconify/react';
import outlineArrowBackIos from '@iconify/icons-ic/outline-arrow-back-ios';
import "./exit.scss"

function Exit() {
    return (
        <>
        <NavLink to="/"><Icon icon={outlineArrowBackIos} className="exit"></Icon></NavLink> 
        </>
    );
}

export default Exit;